import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbComponent implements OnInit {
  @Input() moduleName: string = '';
  @Input() routePath: string = '';
  @Input() userEmail: string = '';
  @Input() btnName: string = 'Create';
  @Input() dataLength: number = 0;
  @Input() showCreate: boolean = false;
  @Input() showList: boolean = false;
  @Input() showBack: boolean = true;
  @Input() showFilter: boolean = false;
  @Input() showFilterBtn: boolean = false;
  @Output() showFilterParams = new EventEmitter();
  constructor() {
  }

  ngOnInit(): void {
  }
  constructString(str: String) {
    return str.split(' ').join('-')
  }
  back() {
    history.back();
  }

  updateFilter() {
    this.showFilter = !this.showFilter
    this.showFilterParams.emit(this.showFilter)
  }
}
